module.exports = __webpack_public_path__ + "static/media/tettigonia_caudata_003_APA.b1ba35c1.mp3";